import { Injectable } from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {ErrorPageModel} from '../../models/ErrorPageModel';

@Injectable
({
  providedIn: 'root'
})
export class ErrorPageService
{
  private _errorPageModel: ErrorPageModel;
  private _cambioEnErrorPageModelEvent: ReplaySubject<ErrorPageModel>;

  get errorPageModel(): ErrorPageModel
  {
    return this._errorPageModel;
  }

  set errorPageModel(value: ErrorPageModel)
  {
    this._errorPageModel = value;
    this._cambioEnErrorPageModelEvent.next(this._errorPageModel);
  }

  get cambioEnErrorPageModelEvent(): ReplaySubject<ErrorPageModel>
  {
    return this._cambioEnErrorPageModelEvent;
  }

  set cambioEnErrorPageModelEvent(value: ReplaySubject<ErrorPageModel>)
  {
    this._cambioEnErrorPageModelEvent = value;
  }

  constructor()
  {
    this._cambioEnErrorPageModelEvent = new ReplaySubject<ErrorPageModel>(1);
  }
}
